import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=126c488e&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=js&"
export * from "./LeftBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=126c488e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c488e",
  null
  
)

export default component.exports